module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-easter-a5154a405698de1128de4c46b6212649.svg";